module.exports = __webpack_public_path__ + "img/buy_booster_nft_credits_button.1a2cf8e0.png";